import { routing } from "../../routing.js";
import { SortOrder } from "../../types/index.js";
export function createClient(api) {
  /**
   * List Contacts Exports with sorting, and pagination.
   */
  async function list(options) {
    const {
      limit,
      offset,
      sortOrder
    } = options;
    return api.get(routing.contactsExportsUrl, {
      query: {
        limit,
        offset,
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }

  /**
   * List Contacts Exports with sorting, pagination, and filtering.
   */
  async function search(options) {
    const {
      query,
      limit,
      offset,
      sortOrder
    } = options;
    const url = `${routing.contactsExportsUrl}/search`;
    return api.post(url, {
      payload: {
        limit,
        offset,
        query,
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }

  /**
   * Fetch Contacts Export object by its uuid.
   */
  async function get(uuid) {
    const url = `${routing.contactsExportsUrl}/${uuid}`;
    const response = await api.get(url);
    return response.export;
  }

  /**
   * Request export of the given selection of Contacts.
   * If the selection size is small enough, it can be processed right away,
   * returning an export with `status: "done"`.
   *
   * Otherwise, returns an export with `status: "new"`,
   * and will notify the user over email when it's done.
   */
  async function create(selector) {
    const {
      query,
      scope
    } = selector;
    const response = await api.post(routing.contactsExportsUrl, {
      payload: {
        contacts: {
          query,
          scope
        }
      }
    });
    return response.export;
  }

  /**
   * Fetch a download URL to retrieve the given Contacts Export file.
   * Only works for exports with status = "done"
   * Fails with Method Not Allowed (405) error for pending and failed exports.
   */
  async function download(uuid) {
    const url = `${routing.contactsExportsUrl}/${uuid}/download`;
    const response = await api.post(url);
    return {
      downloadUrl: response.download_url
    };
  }
  return {
    list,
    search,
    get,
    create,
    download
  };
}